import React from 'react';
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {Colors} from "../../theme/colors";
import {makeStyles} from "@material-ui/core/styles";
import {Grid} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    label: {
        color: '#758089 !important',
        fontSize: '0.9rem !important',
        fontWeight: 400,
        position: 'relative',
        lineHeight: '144% !important',
        transition: 'none',
        transform: 'none',
        marginBottom: '5px'
    },
    radioGroup: {
        paddingLeft: '10px'
    }
}));

export const StyledRadioButton: React.FC<Props> = ({label, options, value, onChange, direction = 'column'}) => {
    const classes = useStyles();

    const controlProps = (item) => ({
        checked: value === item,
        onChange: onChange,
        value: item,
        name: 'color-radio-button-demo',
        inputProps: { 'aria-label': item },
    });

    return (
        <FormControl component="fieldset">
            {label &&
                <FormLabel className={classes.label}>{label}</FormLabel>
            }

            <RadioGroup
                defaultValue={options[0].value}
                className={classes.radioGroup}
            >
                <Grid container direction={direction}>
                    {options.map((option, index) => (
                        <Grid item key={index}>
                            <FormControlLabel key={index} value={option.value} control={<Radio
                                {...controlProps(option.value)}
                                sx={{
                                    '&.Mui-checked': {
                                        color: Colors.primary50,
                                    },
                                }}
                            />} label={option.label} />
                        </Grid>
                    ))}
                </Grid>
            </RadioGroup>
        </FormControl>
    );
}

interface Props {
    label?: string,
    options: {value: string, label: string}[],
    onChange: any,
    value: any,
    direction?: 'column' | 'row'
}
